<div class="hotspot-popup">
  <h3>{{h.title}}</h3>
  <button class="dialog-close-button" [mat-dialog-close]>
    <span class="material-icons"> close </span>
  </button>
  <div [innerHTML]="h.description"></div>
  @if (h.layerIds) {
    <button mat-flat-button (click)="goToMap()">
      Food System Map
    </button>
  }
  @if (h.link) {
    <a mat-flat-button [href]="h.link" target="_blank" class="learn-more">
      Learn More
    </a>
  }
</div>
